
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35242',
  depVersions: {
  "documents-public-ui": "static-1.35242",
  "atom": "static-1.5405",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2800",
  "client-types": "static-1.498",
  "cssUtils": "static-1.940",
  "customer-data-filters-ui": "static-1.40969",
  "customer-data-objects": "static-1.8012",
  "customer-data-property-utils": "static-1.8420",
  "documents-lib": "static-1.35247",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.369",
  "FormsCommonComponents": "static-1.86586",
  "FormUrlGenerator": "static-2.5044",
  "foundations-theming-specialty": "static-1.2509",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5912",
  "hs-test-utils": "static-1.8350",
  "hub-http": "static-1.6532",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12113",
  "HubStyleTokens": "static-2.11806",
  "I18n": "static-7.1676",
  "icons": "static-2.685",
  "jasmine-immutable": "static-1.3340",
  "jasmine-runner": "static-1.6769",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7471",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3210",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5713",
  "quartz": "static-1.7478",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.7",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5567",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8500",
  "reference-resolvers-lite": "static-1.8423",
  "reporting-data": "static-1.68866",
  "reporting-reports": "static-1.68543",
  "reporting-snowflake": "static-1.57483",
  "reporting-testing-lib": "static-1.10799",
  "reporting-visualizations": "static-1.60941",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9270",
  "sanitize": "static-1.4790",
  "sanitize-text": "static-1.8475",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2062",
  "signup-constants": "static-1.19650",
  "signup-ui-url-generator": "static-2.8379",
  "StyleGuideUI": "static-3.503",
  "superstore": "static-1.5075",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5079",
  "ui-addon-form-validation": "static-1.11301",
  "ui-asset-management-lib": "static-1.11416",
  "ui-images": "static-2.1253",
  "UIComponents": "static-3.8752",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7395",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9974",
  "foundations-components": "static-1.8514",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1256",
  "quartz-core": "static-1.6697",
  "quick-fetch": "static-1.4140",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4984",
  "ui-addon-i18n": "static-1.11465",
  "ui-addon-upgrades": "static-9.18403",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3632",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3755",
  "quartz-webpack": "static-1.3702",
  "foundations-assets": "static-1.5203",
  "foundations-theming": "static-1.4793",
  "hub-http-janus": "static-1.883",
  "hub-http-shared-msw-handlers": "static-1.10641",
  "hubspotter-http": "static-1.4874",
  "sassPrefix": "static-1.209",
  "conversations-skeleton-state": "static-1.7566",
  "crm-message-bus": "static-1.43790",
  "customer-data-filters-ui-msw-helpers": "static-1.23404",
  "customer-data-objects-ui-components": "static-1.13349",
  "customer-data-reference-ui-components": "static-1.13495",
  "customer-data-ui-utilities": "static-1.10150",
  "events-data-lib": "static-1.566",
  "framework-builder-read-service-client": "static-1.4233",
  "hs-resources": "static-1.509",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4066",
  "multi-account-reference-resolvers": "static-1.1324",
  "onboarding-scopes": "static-1.6770",
  "onboarding-tours": "static-1.17132",
  "pulse": "static-1.946",
  "reporting-datasets-permissions-lib": "static-1.14490",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2682",
  "trellis-components": "static-1.2701",
  "trellis-theming": "static-1.1291",
  "ui-addon-teams": "static-1.21925",
  "quartz-auth": "static-1.1153",
  "ui-business-units-lib": "static-1.9409",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9745",
  "ContentUtils": "static-1.69147",
  "customer-data-properties": "static-1.52636",
  "forms-ai-lib": "static-1.4782",
  "forms-utils-lib": "static-1.13112",
  "foundations-components-test-utils": "static-1.5997",
  "react-dnd-compat": "static-1.4934",
  "react-tinymce": "static-1.56005",
  "tinymce-config": "static-2.55131",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3778",
  "HeadJS": "static-2.798",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3461",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.305",
  "ui-fonts": "static-1.1068",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4630",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1143",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1862",
  "external-options-client-types": "static-1.4351",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7210",
  "quartz-i18n": "static-1.1153",
  "frontend-preferences-client": "static-1.8240",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4019",
  "reporting-client-types": "static-1.2700",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26210",
  "hubspot-apollo-client": "static-1.5194",
  "foundations-components-legacy": "static-1.1539",
  "quartz-routing": "static-1.908",
  "hs-story-utils": "static-1.9742",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.553",
  "seat-types-lib": "static-1.755",
  "timezone-utils": "static-2.5562",
  "react-create-root-preference": "static-1.73",
  "bend-plugin-foundations-components": "static-1.4783",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.91",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.578",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.466",
  "quartz-test": "static-1.1153",
  "quartz-tracking": "static-1.857",
  "chirp-fetch": "static-1.2213",
  "merchandise-lib": "static-1.278",
  "purchase-motions-components": "static-1.6382",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3276",
  "ts-schema": "static-1.4305",
  "restore-request-side-panel-lib": "static-1.1702",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4974",
  "conditional-properties-service-client": "static-1.4027",
  "crm-pipelines-api-client-types": "static-1.4359",
  "event-emitter": "static-1.1271",
  "fdsr-migration-layer": "static-1.329",
  "multi-currency-client-types": "static-1.3920",
  "getting-started-shared-tasks": "static-1.19269",
  "growth-data-modal": "static-1.5917",
  "growth-onboarding-confetti": "static-1.3380",
  "growth-onboarding-next-action-utils": "static-1.2714",
  "navigation-components": "static-1.18862",
  "onboarding-tours-client": "static-1.5347",
  "onboarding-tours-utils": "static-1.1199",
  "ui-shepherd-react": "static-3.10587",
  "ui-shepherd-tracker": "static-1.7968",
  "ui-universal-auth": "static-1.9425",
  "user-context": "static-1.5439",
  "bend-plugin-pulse": "static-1.449",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.143",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10639",
  "magpie-lib": "static-1.5770",
  "navigation-messaging": "static-1.8189",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23092",
  "copilot-toolkit": "static-1.11867",
  "cms-field-types": "static-1.5132",
  "content-icons-ui": "static-1.2382",
  "integrations-lib": "static-1.17068",
  "calling-global-api": "static-1.65658",
  "calling-internal-common": "static-1.31640",
  "calling-lifecycle-internal": "static-1.67040",
  "calling-lifecycle-messages": "static-1.59334",
  "commerce-products-lib": "static-1.10557",
  "crm-index-visualization-core": "static-1.4562",
  "crm-links": "static-1.6649",
  "customer-data-properties-shared-msw-handlers": "static-1.9968",
  "file-manager-components": "static-1.24531",
  "formula-editor": "static-1.14786",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4439",
  "meetings-icalendar-utils-lib": "static-1.953",
  "object-builder-ui-client": "static-1.49705",
  "pipeline-validation-client-types": "static-1.4194",
  "property-value-citations": "static-1.3250",
  "smart-data-capture-core": "static-1.165",
  "smart-property-lib": "static-1.8323",
  "tiered-pricing": "static-1.1977",
  "topics-actions-lib": "static-1.487",
  "trial-components-library": "static-1.14128",
  "ui-addon-iframeable": "static-1.9394",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "tinymce-themes": "static-1.57101",
  "data-token-picker": "static-1.16909",
  "interframe": "static-3.5072",
  "rich-text-lib": "static-1.20325",
  "tinymce-data": "static-1.41216",
  "tinymce-plugins": "static-1.58245",
  "framework-data-schema-quick-fetch": "static-1.7115",
  "ui-addon-opt": "static-4.8683",
  "hubspot-apollo-cache": "static-1.653",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.468",
  "opentelemetry-web": "static-1.13",
  "purchase-motions-api": "static-1.6385",
  "onboarding-data-sync-lib": "static-1.2533",
  "growth-onboarding-next-action-components": "static-1.2742",
  "user-context-client": "static-1.4824",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5230",
  "nest": "static-1.554",
  "reactive-lib": "static-1.1037",
  "simple-logging-lib": "static-1.3369",
  "unified-auth-core-lib": "static-1.1221",
  "getting-started-shared-tasks-store": "static-1.18387",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1774",
  "integrations-error-boundary-lib": "static-1.14483",
  "integrations-tracking-lib": "static-1.5926",
  "native-integrations-shared-strings": "static-1.8095",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10688",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.939",
  "calling-error-reporting": "static-1.31647",
  "shared-worker-versioning": "static-1.11360",
  "calling-usage-tracker": "static-1.6854",
  "voice-sms-access-library": "static-1.2088",
  "customer-data-tracking": "static-1.7199",
  "commerce-permissions": "static-1.1095",
  "products-iframe-lib": "static-1.8609",
  "products-ui-components-shared-msw-handlers": "static-1.11023",
  "crm-index-associations-lib": "static-1.6758",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10724",
  "sales-views-client-types": "static-1.4574",
  "location-customization-utils-lib": "static-1.10123",
  "immerable": "static-1.4466",
  "video-components-external": "static-1.12169",
  "video-data-lib": "static-1.35827",
  "bark-lib": "static-1.16832",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6207",
  "react-codemirror": "static-1.10960",
  "data-agent-kit": "static-1.666",
  "feedback-loader": "static-1.29831",
  "fsm": "static-1.4068",
  "policy-lib": "static-1.7122",
  "react-colorpicker": "static-2.10534",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10787",
  "embedded-academy-lib": "static-1.15557",
  "hubs-service-types": "static-1.1579",
  "salesImages": "static-1.580",
  "NamespacedHubStyle": "static-2.9276",
  "FileManagerLib": "static-1.40171",
  "FileManagerCore": "static-1.40030",
  "layout-dnd-components": "static-1.12992",
  "ui-addon-emoji-picker": "static-1.10203",
  "ui-brand-identity-lib": "static-1.16539",
  "InboxConnectUtils": "static-4.15582",
  "meetings-connect-utils-lib": "static-1.7928",
  "breeze-engine-chat-components": "static-1.752",
  "breeze-engine-core": "static-1.1052",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3328",
  "adobe-sign-auth-lib": "static-1.487",
  "ads-unified-auth-lib": "static-1.1451",
  "generic-oauth-auth-lib": "static-1.67",
  "google-sheets-integration-lib": "static-1.1054",
  "microsoft-drive-auth-lib": "static-1.170",
  "surveymonkey-integration-lib": "static-1.512",
  "slack-ui-library": "static-1.10716",
  "calling-orchestration-schema": "static-1.36865",
  "crm-record-cards-service-types": "static-1.3796",
  "apollo-dlb": "static-3.86",
  "content-media-composition-data-lib": "static-1.13270",
  "content-media-compositions": "static-2.17277",
  "media-bridge-lib": "static-1.19423",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16389",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4826",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15017",
  "FileManagerImages": "static-1.37682",
  "video-components": "static-1.14171",
  "breeze-artifacts-sdk": "static-1.385",
  "audio-components": "static-1.6364",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4851",
  "video-embed": "static-1.36661",
  "ContentData": "static-1.69222",
  "layout-data-lib": "static-1.10292",
  "layout-dnd-utils": "static-1.11967",
  "hub-http-contrib": "static-1.3357",
  "ui-addon-sales-email": "static-1.5533",
  "academy-service-client": "static-1.4008",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4722",
  "trellis-ecosystem": "static-1.7645",
  "ui-addon-react-router-dom": "static-1.9852",
  "ui-addon-video-player": "static-1.9022",
  "wootric-nps": "static-1.7212",
  "social-insights-client-types": "static-1.22706",
  "content-assistance-lib": "static-1.8218",
  "outpost": "static-1.4471",
  "advanced-menus-core": "static-1.15596",
  "ExportDialog": "static-6.10697",
  "ui-memberships-settings-lib": "static-1.34868",
  "marketplace-ui-apps-core": "static-1.19292",
  "marketplace-ui-common": "static-1.20760",
  "ui-coaching-tips": "static-1.29332",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15595",
  "settings-ui-lib": "static-1.12842",
  "developer-experience-shared-components": "static-1.10857",
  "immutable-less": "static-1.4967",
  "marketplace-ui-client-types": "static-1.18167",
  "ui-addon-integrations-directory-panel": "static-2.8346",
  "ui-extensibility-client-types": "static-1.4236",
  "ai-settings-ui-library": "static-1.8365",
  "nav-meta": "static-1.30499",
  "ui-product-approvals-common": "static-1.1105",
  "growth-onboarding-feedback-components": "static-1.6902",
  "apps-service-types": "static-1.4059",
  "oauth-service-types": "static-1.4553",
  "simple-data-table": "static-1.3544"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35242",
  "atom": "/atom/static-1.5405",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2800",
  "client-types": "/client-types/static-1.498",
  "cssUtils": "/cssUtils/static-1.940",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40969",
  "customer-data-objects": "/customer-data-objects/static-1.8012",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8420",
  "documents-lib": "/documents-lib/static-1.35247",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.369",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86586",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5044",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2509",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5912",
  "hs-test-utils": "/hs-test-utils/static-1.8350",
  "hub-http": "/hub-http/static-1.6532",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12113",
  "HubStyleTokens": "/HubStyleTokens/static-2.11806",
  "I18n": "/I18n/static-7.1676",
  "icons": "/icons/static-2.685",
  "jasmine-immutable": "/jasmine-immutable/static-1.3340",
  "jasmine-runner": "/jasmine-runner/static-1.6769",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7471",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3210",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5713",
  "quartz": "/quartz/static-1.7478",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.7",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5567",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8500",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8423",
  "reporting-data": "/reporting-data/static-1.68866",
  "reporting-reports": "/reporting-reports/static-1.68543",
  "reporting-snowflake": "/reporting-snowflake/static-1.57483",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10799",
  "reporting-visualizations": "/reporting-visualizations/static-1.60941",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9270",
  "sanitize": "/sanitize/static-1.4790",
  "sanitize-text": "/sanitize-text/static-1.8475",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2062",
  "signup-constants": "/signup-constants/static-1.19650",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8379",
  "StyleGuideUI": "/StyleGuideUI/static-3.503",
  "superstore": "/superstore/static-1.5075",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5079",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11301",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11416",
  "ui-images": "/ui-images/static-2.1253",
  "UIComponents": "/UIComponents/static-3.8752",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7395",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9974",
  "foundations-components": "/foundations-components/static-1.8514",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1256",
  "quartz-core": "/quartz-core/static-1.6697",
  "quick-fetch": "/quick-fetch/static-1.4140",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4984",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11465",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18403",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3632",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3755",
  "quartz-webpack": "/quartz-webpack/static-1.3702",
  "foundations-assets": "/foundations-assets/static-1.5203",
  "foundations-theming": "/foundations-theming/static-1.4793",
  "hub-http-janus": "/hub-http-janus/static-1.883",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10641",
  "hubspotter-http": "/hubspotter-http/static-1.4874",
  "sassPrefix": "/sassPrefix/static-1.209",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7566",
  "crm-message-bus": "/crm-message-bus/static-1.43790",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23404",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13349",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13495",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10150",
  "events-data-lib": "/events-data-lib/static-1.566",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4233",
  "hs-resources": "/hs-resources/static-1.509",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1324",
  "onboarding-scopes": "/onboarding-scopes/static-1.6770",
  "onboarding-tours": "/onboarding-tours/static-1.17132",
  "pulse": "/pulse/static-1.946",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14490",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2682",
  "trellis-components": "/trellis-components/static-1.2701",
  "trellis-theming": "/trellis-theming/static-1.1291",
  "ui-addon-teams": "/ui-addon-teams/static-1.21925",
  "quartz-auth": "/quartz-auth/static-1.1153",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9409",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9745",
  "ContentUtils": "/ContentUtils/static-1.69147",
  "customer-data-properties": "/customer-data-properties/static-1.52636",
  "forms-ai-lib": "/forms-ai-lib/static-1.4782",
  "forms-utils-lib": "/forms-utils-lib/static-1.13112",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5997",
  "react-dnd-compat": "/react-dnd-compat/static-1.4934",
  "react-tinymce": "/react-tinymce/static-1.56005",
  "tinymce-config": "/tinymce-config/static-2.55131",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3778",
  "HeadJS": "/HeadJS/static-2.798",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3461",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.305",
  "ui-fonts": "/ui-fonts/static-1.1068",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4630",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1143",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1862",
  "external-options-client-types": "/external-options-client-types/static-1.4351",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7210",
  "quartz-i18n": "/quartz-i18n/static-1.1153",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8240",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4019",
  "reporting-client-types": "/reporting-client-types/static-1.2700",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26210",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5194",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1539",
  "quartz-routing": "/quartz-routing/static-1.908",
  "hs-story-utils": "/hs-story-utils/static-1.9742",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.553",
  "seat-types-lib": "/seat-types-lib/static-1.755",
  "timezone-utils": "/timezone-utils/static-2.5562",
  "react-create-root-preference": "/react-create-root-preference/static-1.73",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4783",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.91",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.578",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.466",
  "quartz-test": "/quartz-test/static-1.1153",
  "quartz-tracking": "/quartz-tracking/static-1.857",
  "chirp-fetch": "/chirp-fetch/static-1.2213",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "purchase-motions-components": "/purchase-motions-components/static-1.6382",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3276",
  "ts-schema": "/ts-schema/static-1.4305",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1702",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4974",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4027",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4359",
  "event-emitter": "/event-emitter/static-1.1271",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.329",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3920",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19269",
  "growth-data-modal": "/growth-data-modal/static-1.5917",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3380",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2714",
  "navigation-components": "/navigation-components/static-1.18862",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5347",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1199",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10587",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7968",
  "ui-universal-auth": "/ui-universal-auth/static-1.9425",
  "user-context": "/user-context/static-1.5439",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.449",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.143",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10639",
  "magpie-lib": "/magpie-lib/static-1.5770",
  "navigation-messaging": "/navigation-messaging/static-1.8189",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23092",
  "copilot-toolkit": "/copilot-toolkit/static-1.11867",
  "cms-field-types": "/cms-field-types/static-1.5132",
  "content-icons-ui": "/content-icons-ui/static-1.2382",
  "integrations-lib": "/integrations-lib/static-1.17068",
  "calling-global-api": "/calling-global-api/static-1.65658",
  "calling-internal-common": "/calling-internal-common/static-1.31640",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67040",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59334",
  "commerce-products-lib": "/commerce-products-lib/static-1.10557",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4562",
  "crm-links": "/crm-links/static-1.6649",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9968",
  "file-manager-components": "/file-manager-components/static-1.24531",
  "formula-editor": "/formula-editor/static-1.14786",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4439",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.953",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49705",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4194",
  "property-value-citations": "/property-value-citations/static-1.3250",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.165",
  "smart-property-lib": "/smart-property-lib/static-1.8323",
  "tiered-pricing": "/tiered-pricing/static-1.1977",
  "topics-actions-lib": "/topics-actions-lib/static-1.487",
  "trial-components-library": "/trial-components-library/static-1.14128",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9394",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "tinymce-themes": "/tinymce-themes/static-1.57101",
  "data-token-picker": "/data-token-picker/static-1.16909",
  "interframe": "/interframe/static-3.5072",
  "rich-text-lib": "/rich-text-lib/static-1.20325",
  "tinymce-data": "/tinymce-data/static-1.41216",
  "tinymce-plugins": "/tinymce-plugins/static-1.58245",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7115",
  "ui-addon-opt": "/ui-addon-opt/static-4.8683",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.653",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.468",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "purchase-motions-api": "/purchase-motions-api/static-1.6385",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2533",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2742",
  "user-context-client": "/user-context-client/static-1.4824",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5230",
  "nest": "/nest/static-1.554",
  "reactive-lib": "/reactive-lib/static-1.1037",
  "simple-logging-lib": "/simple-logging-lib/static-1.3369",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1221",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18387",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1774",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14483",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5926",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8095",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10688",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.939",
  "calling-error-reporting": "/calling-error-reporting/static-1.31647",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11360",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6854",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2088",
  "customer-data-tracking": "/customer-data-tracking/static-1.7199",
  "commerce-permissions": "/commerce-permissions/static-1.1095",
  "products-iframe-lib": "/products-iframe-lib/static-1.8609",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11023",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6758",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10724",
  "sales-views-client-types": "/sales-views-client-types/static-1.4574",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10123",
  "immerable": "/immerable/static-1.4466",
  "video-components-external": "/video-components-external/static-1.12169",
  "video-data-lib": "/video-data-lib/static-1.35827",
  "bark-lib": "/bark-lib/static-1.16832",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6207",
  "react-codemirror": "/react-codemirror/static-1.10960",
  "data-agent-kit": "/data-agent-kit/static-1.666",
  "feedback-loader": "/feedback-loader/static-1.29831",
  "fsm": "/fsm/static-1.4068",
  "policy-lib": "/policy-lib/static-1.7122",
  "react-colorpicker": "/react-colorpicker/static-2.10534",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10787",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15557",
  "hubs-service-types": "/hubs-service-types/static-1.1579",
  "salesImages": "/salesImages/static-1.580",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9276",
  "FileManagerLib": "/FileManagerLib/static-1.40171",
  "FileManagerCore": "/FileManagerCore/static-1.40030",
  "layout-dnd-components": "/layout-dnd-components/static-1.12992",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10203",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16539",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15582",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7928",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.752",
  "breeze-engine-core": "/breeze-engine-core/static-1.1052",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3328",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.487",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1451",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.67",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1054",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.170",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.512",
  "slack-ui-library": "/slack-ui-library/static-1.10716",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36865",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13270",
  "content-media-compositions": "/content-media-compositions/static-2.17277",
  "media-bridge-lib": "/media-bridge-lib/static-1.19423",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16389",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4826",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15017",
  "FileManagerImages": "/FileManagerImages/static-1.37682",
  "video-components": "/video-components/static-1.14171",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.385",
  "audio-components": "/audio-components/static-1.6364",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4851",
  "video-embed": "/video-embed/static-1.36661",
  "ContentData": "/ContentData/static-1.69222",
  "layout-data-lib": "/layout-data-lib/static-1.10292",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11967",
  "hub-http-contrib": "/hub-http-contrib/static-1.3357",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5533",
  "academy-service-client": "/academy-service-client/static-1.4008",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4722",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7645",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9852",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9022",
  "wootric-nps": "/wootric-nps/static-1.7212",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "content-assistance-lib": "/content-assistance-lib/static-1.8218",
  "outpost": "/outpost/static-1.4471",
  "advanced-menus-core": "/advanced-menus-core/static-1.15596",
  "ExportDialog": "/ExportDialog/static-6.10697",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34868",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19292",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20760",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29332",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15595",
  "settings-ui-lib": "/settings-ui-lib/static-1.12842",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10857",
  "immutable-less": "/immutable-less/static-1.4967",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18167",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8346",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4236",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8365",
  "nav-meta": "/nav-meta/static-1.30499",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1105",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6902",
  "apps-service-types": "/apps-service-types/static-1.4059",
  "oauth-service-types": "/oauth-service-types/static-1.4553",
  "simple-data-table": "/simple-data-table/static-1.3544"
}
};
